import { NgModule } from '@angular/core'
import { ForexWarningComponent } from './forex-warning.component'

@NgModule({
  declarations: [ForexWarningComponent],
  exports: [ForexWarningComponent],
})
export class ForexWarningModule {
}
